import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const popupNotificationStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: "11px 16px",
            border: `1px solid ${theme.colors.secondary.sky}`,
            backgroundColor: theme.colors.neutrals.white,
            flexGrow: 1,
            borderRadius: theme.shape.borderRadius,
            display: "flex",
            alignItems: "start",
            fill: theme.colors.secondary.sky,
            color: theme.colors.neutrals.neutral500,
            boxShadow:
                "0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05)",
        },

        success: {
            borderColor: theme.colors.feedback.success,
            fill: theme.colors.feedback.success,
        },

        warning: {
            borderColor: theme.colors.feedback.warning,
            fill: theme.colors.feedback.warning,
        },

        error: {
            borderColor: theme.colors.feedback.error,
            fill: theme.colors.feedback.error,
        },

        contentContainer: {
            marginRight: "15px",
        },

        iconContainer: {
            width: "22px",
            display: "flex",
            alignItems: "center",
            marginRight: "15px",
            alignSelf: "center",
        },

        closeIconContainer: {
            fill: "#373F41",
            width: "30px",
            height: "30px",
            margin: "-10px",
            display: "flex",

            "& svg": {
                width: "10px",
            },
        },

        grow: {
            flexGrow: 1,
        },

        detailsButton: {
            color: theme.colors.primary.blue500,
            textDecoration: "underline",
        },
    })
);
